import * as types from '../constants';

export const orderDetailsFlags = {
  'interagency-pass-enabled': false
};

const INITIALSTATE = {
  results: {},
  flags: Object.assign({}, orderDetailsFlags)
};

export default function orderdetails(state = INITIALSTATE, action) {
  const st = Object.assign({}, state);

  switch (action.type) {
    case types.ADD_ITEM_ERROR:
      st.err_message = action.payload;
      st.item_errors = action.item_add_errors;
      delete st.err;
      return st;
    case types.SET_FLAGS_ORDER_DETAILS:
      st.flags = action.flags;
      return st;
    default:
      return st;
  }
}
